import hero5 from '../../assets/img/hero/bpr.jpg';
import hero6 from '../../assets/img/hero/bpr2.jpg';
import hero7 from '../../assets/img/hero/bpr3.jpg';
import hero8 from '../../assets/img/hero/bpr4.jpg';

export default function Hero() {
    return (
        <section className="bg-white dark:bg-gray-900 ">
            <div className="grid max-w-screen-2xl px-3 lg:px-16 py-8 mx-auto lg:gap-16 xl:gap-16 lg:py-16 lg:grid-cols-12">
                <div className="mr-auto place-self-center lg:col-span-7 space-y-6 mb-3 lg:mb-0">
                    <h1 className="max-w-2xl mb-4 text-4xl font-extrabold tracking-tight leading-none md:text-5xl xl:text-6xl dark:text-white">
                        Raih Karier Impianmu
                    </h1>
                    <p className="max-w-2xl font-light text-gray-500 lg:mb-8 md:text-lg lg:text-xl dark:text-gray-400">
                        Bergabunglah dengan BPR Palu Anugerah dan temukan peluang karier terbaik untuk masa depanmu.
                    </p>
                    <div className='grid grid-cols-1 gap-6  md:grid-cols-2 lg:grid-cols-2 '>
                        <div className="p-6 bg-blue-100 dark:bg-gray-800 rounded-lg shadow">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">4 Kantor Cabang & 2 Kantor Kas</h3>
                            <p className="text-sm text-gray-600 dark:text-gray-300">Kesempatan bekerja di berbagai wilayah Sulawesi Tengah.</p>
                        </div>
                        <div className="p-6 bg-green-100 dark:bg-gray-800 rounded-lg shadow">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Fasilitas & Insentif Menarik</h3>
                            <p className="text-sm text-gray-600 dark:text-gray-300">Nikmati gaji yang kompetitif, tunjangan lengkap, serta lingkungan kerja yang mendukung.</p>
                        </div>
                        <div className="p-6 bg-pink-100 dark:bg-gray-800 rounded-lg shadow">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Penempatan Strategis</h3>
                            <p className="text-sm text-gray-600 dark:text-gray-300">Bekerja di berbagai kota dengan peluang berkembang yang luas.</p>
                        </div>
                        <div className="p-6 bg-red-100 dark:bg-gray-800 rounded-lg shadow">
                            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">Keuntungan Karier</h3>
                            <p className="text-sm text-gray-600 dark:text-gray-300">Dapatkan kesempatan berkembang dan jenjang karier yang jelas.</p>
                        </div>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-6 lg:col-span-5 relative">
                    <div className="relative">
                        <img src={hero6} alt="Hero 1" className="w-full h-auto rounded-lg shadow" />
                        <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white text-sm p-3 rounded">
                            Tim Ahli & Berpengalaman
                        </div>
                    </div>
                    <div className="relative">
                        <img src={hero5} alt="Hero 2" className="w-full h-auto rounded-lg shadow" />
                        <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white text-sm p-3 rounded">
                            Prospek Karier yang Jelas
                        </div>
                    </div>
                    <div className="relative">
                        <img src={hero7} alt="Hero 3" className="w-full h-auto rounded-lg shadow" />
                        <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white text-sm p-3 rounded">
                            Budaya Kerja Nyaman
                        </div>
                    </div>
                    <div className="relative">
                        <img src={hero8} alt="Hero 4" className="w-full h-auto rounded-lg shadow" />
                        <div className="absolute bottom-4 left-4 bg-black bg-opacity-50 text-white text-sm p-3 rounded">
                            Kesempatan Berkembang
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}